import Styles from './styles.module.css';
import React, { useEffect, useState } from 'react';
import { collection, getDocs, getFirestore, limit, query } from 'firebase/firestore';
import { ApplicantRow } from '../types';
import EvaluationSummary from '../panel/EvaluationSummary';
import ApplicationRounds from './ApplicationRounds';
import { useAppSelector } from 'src/salon/app/hook';

type Props = {
  applicant: ApplicantRow;
  onChanged: (patch: Partial<ApplicantRow>) => void;
  isVisit?: boolean;
};

// 応募後の評価タブ。◎○△×の評価入力は「審査」画面(16.judging)だけで行うようにし、
// ここでは選考段階の変更・審査員全員の集計結果の閲覧(EvaluationSummary)のみを表示する
// (以前あった「評価入力」サブタブ・EvaluationFormは、審査画面と二重に評価できて
// しまうため廃止した)。isVisitはサロン見学(単一ラウンド)の審査結果を表示する場合に渡す。
//
// 見学していた学生が応募すると、同じチャット(同じID)の種類が「見学」→「応募」に変わる。
// 見学のときの審査員の評価(chats/{id}/visitExamination)はそのまま残っているため、
// 応募の学生でも見学の評価が1件でもあれば、選考の評価の下に「サロン見学時の評価」として並べる。
//
// 応募の学生には、その下に募集回ごとの記録(アーカイブ)を出す。審査員には見せない。
const EvaluationTab: React.FC<Props> = ({ applicant, onChanged, isVisit }) => {
  const company = useAppSelector((state) => state.company.company);
  const [ hasVisitEvaluation, setHasVisitEvaluation ] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setHasVisitEvaluation(false);
    if (isVisit) return;
    getDocs(query(collection(getFirestore(), 'chats', applicant.id, 'visitExamination'), limit(1)))
      .then((snap) => { if (!cancelled) setHasVisitEvaluation(!snap.empty); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [applicant.id, isVisit]);

  return (
    <>
      <EvaluationSummary applicant={applicant} onChanged={onChanged} isVisit={isVisit} />
      {hasVisitEvaluation && (
        <div className={Styles.visitEvaluationSection}>
          <p className={Styles.visitEvaluationLead}>この学生は応募前にサロン見学をしています。見学のときの審査員の評価です。</p>
          <EvaluationSummary
            applicant={{ ...applicant, examination: 0 }}
            onChanged={() => {}}
            isVisit
          />
        </div>
      )}
      {!isVisit && company.role !== 'judge' && <ApplicationRounds applicantId={applicant.id} />}
    </>
  );
};

export default EvaluationTab;
